// extracted by mini-css-extract-plugin
export default {"container":"bX-z","title":"cX-z","link":"dX-z"};